var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-excel-xlsx',{attrs:{"data":_vm.items,"columns":_vm.convertToExcelLabel(_vm.headers),"file-name":'DANH_SACH_PHIEU_HT',"file-type":'xlsx',"sheet-name":'sheetname'}},[_c('v-list-item-title',[_c('v-btn',{staticClass:"my-2",attrs:{"color":"teal darken-4","small":"","outlined":""}},[_vm._v("Xuất excel")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }